import { render, staticRenderFns } from "./PeriodSelector.vue?vue&type=template&id=61453b8a&scoped=true"
import script from "./PeriodSelector.vue?vue&type=script&lang=js"
export * from "./PeriodSelector.vue?vue&type=script&lang=js"
import style0 from "./PeriodSelector.vue?vue&type=style&index=0&id=61453b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61453b8a",
  null
  
)

export default component.exports